import { useTranslation } from 'react-i18next';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import DocChip from './DocChip';
import styles from './AiAssistant.module.scss';

type Props = {
  name: string;
  onRemove: () => void;
};

// A document pinned to the composer as a removable token — the shared DocChip
// shell with a trailing remove control. On send its reference is folded into
// the outgoing message by ChatInput.
function ComposerDocChip({ name, onRemove }: Props) {
  const { t } = useTranslation();
  return (
    <DocChip
      label={name}
      trailing={
        <button
          type="button"
          className={styles.docRefChipRemove}
          onClick={onRemove}
          aria-label={t('remove')}
        >
          <MaterialIcon icon="cancel" symbolsOutlined size="md-20" />
        </button>
      }
    />
  );
}

export default ComposerDocChip;
